export default [
  {
    path: '/',
    name: 'Login Page',
    view: "LoginPage",
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    view: "LicenseDashboard",
    meta: { requiresAuth: true }
  },
  {
    path: '/admin-dashboard',
    name: 'Manage Users',
    view: "AdminDashboard",
    meta: { requiresPowerAuth: true }
  },
  {
    path: '/user-profile',
    name: 'User Profile',
    view: "UserProfile",
    meta: { requiresAuth: true }
  }
]
